import { generateCandidateSummary, generateJobDescription, generateQuestions } from "../../../../api/generative-ai";
import { getAllSkillsOptions } from "../../../recruitment/processes/edit/process-creation-helpers/process-creation-api-helper";
import { QuestionTones } from "./helpers/gen-ai-helper";

export enum CopilotActionID {
  InterviewQuestionGenerator_0 = "INTERVIEW_QUESTION_GENERATOR_0",
  InterviewQuestionGenerator_1 = "INTERVIEW_QUESTION_GENERATOR_1",
  CandidateSummaryGenerator = "CANDIDATE_SUMMARY_GENERATOR",
  JobDescriptionGenerator = "JOB_DESCRIPTION_GENERATOR",
}

export enum CopilotActionType {
  multiSelect = "multiSelect",
  singleSelect = "singleSelect",
  input = "input",
  textarea = "textarea",
  simpleOptions = "simpleOptions",
}

export interface CopilotAction {
  id: CopilotActionID; // Action identifier
  label: string; // Main action title
  apiCall: Function; // API call function
  loadingText?: string; // This is an optional text that is displayed when the API call is triggered
  steps?: CopilotActionSteps[]; // This steps define some additional inputs needed to retrive extra data from the user
  feature?: string; // Name of the feature if is feature dependant
  copilotDialogTitle?: string; // Main title of the copilot dialog
}

export interface CopilotActionSteps {
  label: string; // Step title
  type: CopilotActionType; // Action answer type
  id: string; // This is the id for the input on the form
  answers?: CopilotActionAnswer[] | Function; // List of possible answers if is null the idea is to push the options base of the user context
  skip?: CopilotActionConditional[]; // This is the defenition of when this step should be skipped
  hideStartOver?: boolean; // If true, the start over action is hiden
  nextStep?: string; // Next step id
}

export interface CopilotActionConditional {
  name: string; // Name of the field that will trigger the conditional
  values?: string[]; // Posible values of the field that will trigger the conditional
  nextStep?: string; // Next step id
}

interface CopilotActionAnswer {
  label: string; // Answer text or placeholder in case is an input type answer
  value?: string; // Answer internal value for multiple options answer types
  nextStep?: string; // Next step id
  icon?: string; // Optional name for a material icon
}

export const COPILOT_ACTION: CopilotAction[] = [
  {
    id: CopilotActionID.InterviewQuestionGenerator_0,
    label: "ai.generate.questions",
    loadingText: "copilot.default.loading.label",
    apiCall: generateQuestions,
    steps: [
      {
        id: "jobTitle",
        label: "ai.generate.questions.step.1",
        type: CopilotActionType.input,
        answers: [{ label: "ai.job.title", nextStep: "skills" }],
        skip: [{ name: "jobTitle", nextStep: "skills" }],
        hideStartOver: true,
      },
      {
        id: "skills",
        label: "ai.generate.questions.step.2",
        type: CopilotActionType.multiSelect,
        answers: getAllSkillsOptions,
        skip: [{ name: "skills", nextStep: "tone" }],
        nextStep: "tone",
      },
      {
        id: "tone",
        label: "ai.generate.questions.step.3",
        type: CopilotActionType.singleSelect,
        answers: [
          { label: "ai.generate.question.tone.1", value: QuestionTones.ENGAGING },
          { label: "ai.generate.question.tone.2", value: QuestionTones.FORMAL },
          { label: "ai.generate.question.tone.3", value: QuestionTones.FRIENDLY },
        ],
        skip: [{ name: "tone" }],
      },
    ],
    feature: "interview-question-generator",
  },
  {
    id: CopilotActionID.InterviewQuestionGenerator_1,
    label: "ai.generate.question.skill",
    loadingText: "copilot.default.loading.label",
    apiCall: generateQuestions,
    steps: [
      {
        id: "jobTitle",
        label: "ai.generate.questions.step.1",
        type: CopilotActionType.input,
        answers: [{ label: "ai.job.title", nextStep: "tone" }],
        skip: [{ name: "jobTitle", nextStep: "tone" }],
        hideStartOver: true,
      },
      {
        id: "tone",
        label: "ai.generate.questions.step.3",
        type: CopilotActionType.singleSelect,
        answers: [
          { label: "ai.generate.question.tone.1", value: QuestionTones.ENGAGING },
          { label: "ai.generate.question.tone.2", value: QuestionTones.FORMAL },
          { label: "ai.generate.question.tone.3", value: QuestionTones.FRIENDLY },
        ],
        skip: [{ name: "tone" }],
      },
    ],
    feature: "interview-question-generator",
  },
  {
    id: CopilotActionID.CandidateSummaryGenerator,
    label: "ai.create.candidate.summary",
    loadingText: "copilot.default.loading.label",
    copilotDialogTitle: "ai.copilot.dialog.title",
    apiCall: generateCandidateSummary,
    feature: "ai-summary-generator",
  },
  {
    id: CopilotActionID.JobDescriptionGenerator,
    label: "ai.job.description.generator",
    loadingText: "copilot.default.loading.label",
    copilotDialogTitle: "ai.job.description.generator.title",
    apiCall: generateJobDescription,
    steps: [
      {
        id: "jdSections",
        label: "ai.job.description.generator.1",
        type: CopilotActionType.multiSelect,
        nextStep: "tone",
        hideStartOver: true,
      },
      {
        id: "tone",
        label: "ai.job.description.generator.2",
        type: CopilotActionType.singleSelect,
        answers: [
          { label: "ai.generate.question.tone.1", value: QuestionTones.ENGAGING },
          { label: "ai.generate.question.tone.2", value: QuestionTones.FORMAL },
          { label: "ai.generate.question.tone.3", value: QuestionTones.FRIENDLY },
        ],
        nextStep: "additional_details",
        hideStartOver: true,
      },
      {
        id: "additional_details",
        label: "ai.job.description.generator.3",
        type: CopilotActionType.textarea,
        answers: [{ label: "" }],
        hideStartOver: true,
      },
    ],
    feature: "jd-generator-v2",
  },
];
